<template>
  <el-row :gutter="0" class="header">
    <el-col class="part-first" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
      <el-row>
        <el-col class="part-first-1" :xs="11" :sm="11" :md="11" :lg="11" :xl="11" align="left">
          <div id="logoToPrint" class="header-logo header-btn" @click="resetApp"></div>
        </el-col>
        <el-col class="part-first-2" :xs="11" :sm="11" :md="11" :lg="11" :xl="11" align="center">
          <el-badge :value="nbUnconfirmedResaLenght" :hidden="nbUnconfirmedResaLenght <= 0" class="item">
            <el-popover placement="bottom" :disabled="getNotifDisable" width="383" trigger="click" v-model="popupNotif"
              popper-class="header-notif-popup">
              <div class="header-notif-scrollable" :style="{ height: (getUnConfirmedResa.length * 88) + 30 + 'px' }">
                <div class="header-notif-container">
                  <resa-notif v-for="resa in getUnConfirmedResa" :key="resa.id" :resa="resa"
                    v-on:bubleclose="popupNotif = false"></resa-notif>
                </div>
              </div>
              <div slot="reference" class="header-btn">
                <div class="header-notif"></div>
              </div>
            </el-popover>
          </el-badge>
        </el-col>
        <el-col class="mobile-hide" :xs="2" :sm="2" :md="2" :lg="2" :xl="2" align="center">
          <div class="header-separator"></div>
        </el-col>
        <el-col class="part-first-3" :xs="2" :sm="0" :md="0" :lg="0" :xl="0" align="center">
          <div class="header-btn" @click="clickPopupTakeResa">
            <div class="header-booking"></div>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="part-second" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
      <calendar-nav />
    </el-col>
    <el-col class="part-second" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
      <services-nav />
    </el-col>
    <el-col class="part-second mobile-show-header" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
      <room-nav />
    </el-col>
    <el-col class="part-third" :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" align="center">
          <div class="header-separator"></div>
        </el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" align="center">
          <div class="header-btn" @click="clickPopupTakeResa">
            <div class="header-booking"></div>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CalendarNav from '../calendar/CalendarNav'
import ResaNotif from '../reservation/ResaNotif'
import RoomNav from '../room/RoomNav'
import ServicesNav from '../services/ServicesNav'

export default {
  name: 'MainHeader',
  data() {
    return {
      popupNotif: false
    }
  },
  computed: {
    ...mapGetters({
      getUnConfirmedResa: 'newReservations/getUnConfirmedResa',
      getSelectedDay: 'calendar/getSelectedDay'
    }),
    nbUnconfirmedResaLenght: function () {
      return this.getUnConfirmedResa.length
    },
    getNotifDisable: function () {
      if (this.nbUnconfirmedResaLenght > 0) return false
      this.popupNotif = false
      return true
    }
  },
  methods: {
    ...mapActions({
      showHidePopupTakeResa: 'displayer/showHidePopupTakeResa',
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      moveToThisMonthAndDay: 'calendar/moveToThisMonthAndDay',
      hideAll: 'displayer/hideAll',
      unSelectedTables: 'newRooms/unSelectedTables'
    }),
    ...mapMutations({
      setSelectedService: 'newServices/setSelectedService',
      setSelectedResa: 'newReservations/setSelectedResa',
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setVisibilityCalendar: 'calendar/setVisibilityCalendar'
    }),
    bookCalendar: function () {
      this.$router.replace('/booking')
    },
    clickPopupTakeResa: function () {
      this.setSelectedResa(null)
      this.showHidePopupTakeResa()
    },
    openPopupNotif: function () {
      if (!this.getNotifDisable) {
        this.popupNotif = !this.popupNotif
      } else {
        this.popupNotif = false
      }
    },
    resetApp: function () {
      this.moveToThisMonthAndDay().then(() => {
        this.findFirstOpenServiceHours({ day: this.getSelectedDay, keepCurrent: true, passed: false, checkLock: false }).then((tabHS) => {
          this.setSelectedService({ ms: tabHS[Object.keys(tabHS)[0]].tab[0].ms, subs: tabHS[Object.keys(tabHS)[0]].tab[0].subs })
          this.setSelectedRoom('')
          this.setVisibilityCalendar(false)
          this.hideAll()
          this.unSelectedTables()
        })
      })
    }
  },
  components: { CalendarNav, ServicesNav, ResaNotif, RoomNav }
}
</script>

<style lang="scss">
@use "../../styles/components/layout/header";
@use "../../styles/mixins";

.part {
  &-first {
    @include mixins.mobile-portrait {
      width: 100% !important;
    }

    &-1 {
      @include mixins.mobile-portrait {
        width: 33% !important;
      }
    }

    &-2 {
      @include mixins.mobile-portrait {
        width: 33% !important;
      }
    }

    &-3 {
      display: none;

      @include mixins.mobile-portrait {
        display: initial;
        width: 33% !important;
        text-align: right;
        text-align: -webkit-right;
      }
    }
  }

  &-second {
    @include mixins.mobile-portrait {
      width: 100% !important;
    }
  }

  &-third {
    display: initial;

    @include mixins.mobile-portrait {
      display: none;
    }
  }
}

.mobile-hide {
  @include mixins.mobile-portrait {
    display: none !important;
  }
}

.mobile-show-header {
  display: none;

  @include mixins.mobile-portrait {
    display: block !important;
  }
}
</style>
